<template>
  <div ref="chartWrapper"
       class="widget-wrapper"
  >
    <div class="widget-contents">
      <div class="widget-contents-wrapper">
        <non-trend-chart ref="chartInstance"
                         class="widget-contents-chart"
                         :type="'sunburst'"
                         :legend=false
                         :tooltip="toolTip"
                         :data="widgetData"
                         :series-options="seriesOptions"
        />
      </div>
    </div>
  </div>
</template>
<script>
  // Mixin 객체
  import {widgetMixin} from '~/mixins/widgetCommonMixin'

  // 스토어 헬퍼
  import {createNamespacedHelpers} from 'vuex'

  // 스토어 헬퍼 객체!
  const {mapActions} = createNamespacedHelpers('dashboard/dashboard')

  export default {
    name: 'widgetSecThreatCategory',
    directives: {},
    mixins: [widgetMixin],
    data () {
      return {
        w: 2,
        opts: {
          chartType: 'sunburst'
        },
        title: 'widgetSecThreatCategory',
        isLock: false,
        isMove: true,
        isResize: false,
        eventBus: true,
        deviceType: [20, 21, 23],
        // isIpType: true,
        restData: {
          result: [],
          unit_time: ''
        },
        seriesOptions: {
          label: {
            show: true,
            align: 'right',
            rotate: 0,
            minAngle: 15,
            fontSize: 10,
            position: 'outside',
            overflow: 'truncate',
            distance: 25,
            verticalAlign: 'middle'
          }
        },
        widgetData: []
      }
    },
    computed: {
      toolTip () {
        return {
          formatter: (params) => {
            const {name, value, marker} = _.isArray(params) ? params[0] : params
            return `${marker} ${name === '' ? this.$t('cmn.all') : name} : <b>${this.separateByComma(value)}${this.restData.unit_time}</b>`
          }
        }
      }
    },
    beforeCreate () {},
    created () {},
    beforeMount () {},
    mounted () {},
    beforeUpdate () {},
    updated () {},
    activated () {},
    deactivated () {},
    beforeDestroy () {},
    destroyed () {},
    errorCaptured () {},
    methods: {
      ...mapActions([
        'getWidgetData'
      ]),
      // 위젯 대상 장비 필터 설정.
      async onChangeWidgetMachId ({ machId }) {
        // 위젯 옵션 변경 - 저장에 필요한 값???
        this.opts.mach_id = machId
        this.getWidgetContentsData(true, machId)
      },
      async getWidgetContentsData (init = false, extraParams = null) {
        // Progress 출력 여부
        this.showProgress(true)

        // initFlag가 True면 기존 차트 데이터 초기
        if (init) {
          // 위젯 데이터 초기화
          this.widgetData = []

          // Series 초기화
          this.$refs.chartInstance.clear()
        }

        const contentsOptions = {
          widgetType: 'threat_category_top'
        }

        // 장비 filter 추가
        if (this.opts.mach_id) {
          contentsOptions.machId = this.opts.mach_id
        }

        // 엑스트라 파라미터가 있는 경우 (Device Filter를 선택하여 데이터를 다시 불러와야 하는 경우)
        if (extraParams && extraParams.machId) {
          contentsOptions.machId = extraParams.machId
        }

        // API 호출
        const {code, result} = await this.getWidgetData(contentsOptions)

        // Series 데이터 구헝
        if (code === 'ok') {
          // Rest data 추가
          this.restData = result

          const threatSeries = []
          const resultData = this.restData.result || []
          const category = [...new Set(resultData.map(({ type }) => (type)))]

          for (const _category of category) {
            threatSeries.push({
              name: _category,
              labelLine: {
                show: false
              },
              children: []
            })
          }
          // 보안위협 카테고리 분석
          resultData.forEach(threatCategory => {
            const obj = threatSeries.find((item) => item.name === threatCategory.type)

            if (obj) {
              obj.children.push({
                name: threatCategory.name,
                value: threatCategory.value
              })
            }
          })
          this.widgetData = threatSeries
        }
        // Progress 출력 여부
        this.showProgress(false)
      }
    },
    watch: {}
  }
</script>

<style scoped>
  .widget-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
  }

  .widget-contents {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }

  .widget-contents-wrapper {
    flex-grow: 1;
    display: flex;
  }

  .widget-contents-chart {
    flex-grow: 1;
  }
</style>
